export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-android-c9cdcebe97097a0094e6d4641d19705d.svg";